document.addEventListener('DOMContentLoaded', () => {
  const tiles = document.querySelectorAll('.ineffable-subscription-tile');

  tiles.forEach((tile) => {
    const slides = tile.querySelectorAll('.ineffable-subscription-slide');
    const progressFills = tile.querySelectorAll('.ineffable-subscription-progress-fill');

    if (slides.length < 2) return;

    let currentSlide = 0;
    const duration = 5000;

    const resetProgress = () => {
      progressFills.forEach((fill, index) => {
        fill.style.transition = 'none';
        fill.style.width = index < currentSlide ? '100%' : '0%';
      });

      const activeFill = progressFills[currentSlide];

      if (!activeFill) return;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          activeFill.style.transition = `width ${duration}ms linear`;
          activeFill.style.width = '100%';
        });
      });
    };

    resetProgress();

    setInterval(() => {
      slides[currentSlide].style.opacity = '0';

      currentSlide = (currentSlide + 1) % slides.length;

      slides[currentSlide].style.opacity = '1';

      resetProgress();
    }, duration);
  });
});